define.alias("shared/services/shared/popup-manager", "calendar/services/shared/popup-manager");